
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Film } from "lucide-react";
import { Project } from '@/hooks/useProjects';
import ProjectCard from './ProjectCard';

interface ProjectGridProps {
  projects: Project[];
  isLoading: boolean;
  onCreateProject: () => void;
}

const ProjectGrid = ({ projects, isLoading, onCreateProject }: ProjectGridProps) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="h-64 bg-white/5 border border-white/10 rounded-xl animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-12 max-w-md mx-auto backdrop-blur-sm">
          <div className="w-16 h-16 bg-purple-600/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Film className="h-8 w-8 text-purple-400" />
          </div>
          <h3 className="text-xl font-semibold text-white mb-3">
            No projects yet
          </h3>
          <p className="text-gray-300 mb-6">
            Create your first video project to get started with AI-powered video creation.
          </p>
          <Button
            onClick={onCreateProject}
            className="bg-purple-600 hover:bg-purple-700 text-white"
          >
            <Plus className="h-4 w-4 mr-2" />
            Create Your First Project
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {projects.map((project) => (
        <ProjectCard key={project.id} project={project} />
      ))}
    </div>
  );
};

export default ProjectGrid;
